import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

const COPY = {
  en: {
    text: "We use cookies to keep you signed in, remember your language and improve Suppev. See our",
    privacy: "Privacy Policy",
    accept: "Accept all",
    reject: "Essential only",
  },
  es: {
    text: "Usamos cookies para mantener tu sesión, recordar tu idioma y mejorar Suppev. Consulta nuestra",
    privacy: "Política de Privacidad",
    accept: "Aceptar todo",
    reject: "Solo esenciales",
  },
};

export const CookieBanner = () => {
  const { lang } = useLang();
  const c = COPY[lang] || COPY.en;
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem("mutatoni_cookie_consent")) setShow(true);
  }, []);

  const decide = (value) => {
    localStorage.setItem("mutatoni_cookie_consent", value);
    setShow(false);
  };

  if (!show) return null;

  return (
    <div data-testid="cookie-banner" className="fixed inset-x-3 bottom-3 z-[60] mx-auto max-w-3xl">
      <div className="flex flex-col items-start gap-4 rounded-2xl border border-gray-200 bg-white/95 p-5 shadow-xl backdrop-blur-xl sm:flex-row sm:items-center">
        <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-emerald-50 text-emerald-600">
          <Cookie size={22} />
        </div>
        <p className="flex-1 text-sm leading-relaxed text-gray-600">
          {c.text}{" "}
          <Link to="/privacy" className="font-semibold text-emerald-600 hover:underline">{c.privacy}</Link>.
        </p>
        <div className="flex w-full shrink-0 gap-2 sm:w-auto">
          <button data-testid="cookie-reject" onClick={() => decide("essential")}
            className="flex-1 rounded-full border border-gray-200 px-4 py-2.5 text-sm font-semibold text-gray-700 transition-colors hover:bg-gray-50 sm:flex-none">
            {c.reject}
          </button>
          <button data-testid="cookie-accept" onClick={() => decide("all")}
            className="flex-1 rounded-full bg-emerald-500 px-5 py-2.5 text-sm font-bold text-white transition-colors hover:bg-emerald-600 sm:flex-none">
            {c.accept}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
